import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { Table } from "../../generic/table/Table";
import { CoopPointsToCollect } from "./CoopPointsToCollect";
export var CoopHelpMembersPoints = function (_a) {
    var headers = _a.headers, totalPoints = _a.totalPoints, rows = _a.rows;
    return (React.createElement("div", { className: IdStyles.CoopHelpPointsReceivedContainer + " " + IdStyles.TextNormal + " flex flex--stacked flex--spaced" },
        React.createElement(Table, { headers: headers, rows: rows, tableContainerClassName: "flex flex--stacked" }),
        React.createElement(CoopPointsToCollect, { totalPoints: totalPoints })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/help/CoopHelpMembersPoints.tsx
// module id = 2603
// module chunks = 3